<template>
	<el-button class="record-button" :class="{ 'record-button--recording': recording }" :type="buttonType" @click="toggleRecording" circle><ion-icon class="record-button__icon" :name="buttonIcon"></ion-icon></el-button>
</template>

<script>
	
	export default {
		
		props: {
			
			small: { default: false },
			
			client_id: { default: null },
			project_id: { default: null },
			ticket_id: { default: null },
			
			ticket: { default: function() { return {}; } },
			
		},
		
		computed: {
			
			recording() {
				return this.$store.state.timebook.recording && this.$store.state.timebook.ticket_id == this.ticket_id;
			},
			
			buttonType() {
				if (this.recording) {
					return "danger";
				}
				return "success";
			},
			
			buttonIcon() {
				if (this.recording) {
					return "close";
				}
				return "play";
			},
			
		},
		
		methods: {
			
			toggleRecording() {
				
				this.$store.commit("toggleTimeBookRecording", {
					
					client_id: this.client_id,
					project_id: this.project_id,
					ticket_id: this.ticket_id,
					
					ticket: this.ticket,
					
					user_id: this.$auth.user().id,
					
					callback: (e) => {
						if (e.state == "success") {
							this.$store.commit("theTime");
						}
					},
					
				});
				
			}
			
		},
		
	}
	
</script>

<style lang="scss">
	
	.record-button {
		
		width: 24px;
		height: 24px;
		padding: 0 !important;
		position: relative;
		margin: 0;
		
		&__icon {
			margin: 0;
		    width: 22px;
		    height: 14px;
		    top: 4px;
		    left: 1px;
		    position: absolute;
		}
		
		&--recording {
			
			.record-button__icon {
				left: 0;
			}
			
		}
		
	}
	
</style>


// WEBPACK FOOTER //
// src/components/TimeBook/RecordButton.vue